export const versionComparator = (versionA?: string, versionB?: string): -1 | 0 | 1 => {
  if (!versionA || !versionB) return 0;

  const versionTokensA: number[] = versionA.split('.').map((token) => +token);
  const versionTokensB: number[] = versionB.split('.').map((token) => +token);
  const maxSize = Math.max(versionTokensA.length, versionTokensB.length);

  for (let i = 0; i < maxSize; i++) {
    if ((i < versionTokensA.length ? versionTokensA[i] : 0) > (i < versionTokensB.length ? versionTokensB[i] : 0)) {
      return 1;
    } else if ((i < versionTokensA.length ? versionTokensA[i] : 0) < (i < versionTokensB.length ? versionTokensB[i] : 0)) {
      return -1;
    }
  }

  return 0;
}
